// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-5fT_L";
var _3 = "icon-17CsM";
export { _1 as "__esModule", _2 as "root", _3 as "icon" }
export default { "__esModule": _1, "root": _2, "icon": _3 }
